import { FAQ } from "../static_faqs/types";

export const tataNeuFaqs: FAQ[] = [
  {
    question: "What is Tata Neu?",
    answer: "Tata Neu is a platform for buying and selling gift cards.",
  },
];
